import { render, staticRenderFns } from "./BtnInserirSubItem.vue?vue&type=template&id=42d9cb8b&"
import script from "./BtnInserirSubItem.vue?vue&type=script&lang=js&"
export * from "./BtnInserirSubItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports